import router from './router'
import {checkAdmin} from '@/api/home'

router.beforeEach((to, from, next) =>{
    if(to.path === '/') {
      checkAdmin().then(res =>{
        if(res.message === 'false'){
            next({path:'/welcome'})
        }else{
            next({path:'/admin'})
        }
      })
    }
    if(to.path === '/admin') {
        checkAdmin().then(res =>{
            if(res.message === 'false'){
                next({path:'/welcome'})
            }else{
                next()
            }
        })
    } else {
        next()
    }
})




// WEBPACK FOOTER //
// ./src/javascript/home/permission.js